<template>
  <CModal
    :show.sync="showCenterApprovalModal"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Modal title 2"
    size="lg"
    class="view-log-modal hos-modal small-table-padding modal-width"
  >
    <template #header>
      <h6 class="modal-title">Verify Centre</h6>
      <div v-if="centerData && centerData.registration_proof_image_url">
        <download-image
          :imgSrc="centerData.registration_proof_image_url"
          v-if="checkIfImage(centerData.registration_proof_image_url)"
        ></download-image>
      </div>
      <CButtonClose @click="closeModal()" />
    </template>
    <div v-if="centerData && centerData.registration_proof_image_url">
      <div
        class="text-center"
        v-if="
          statusType === 'View' ||
          statusType === 'Verify' ||
          statusType === 'Reason'
        "
      >
        <image-view
          :zoomImg="true"
          :src="centerData.registration_proof_image_url"
          v-if="checkIfImage(centerData.registration_proof_image_url)"
        ></image-view>
        <pdf-component
          :src="centerData.registration_proof_image_url"
          :styles="'width: 100%; height: 800px'"
          v-else
        ></pdf-component>
      </div>
    </div>

    <div v-else>
      <h2>Certificate not uploaded !</h2>
    </div>

    <div v-if="statusType === 'Reason'" class="border-top mt-2 pt-5">
      <h5>Reason</h5>
      <div>{{ centerData.rejected_details.rejected_reason }}</div>
    </div>
    <div
      v-if="
        statusType === 'Verify' ||
        statusType === 'View' ||
        statusType === 'Reject'
      "
    >
      <div v-if="isReject" class="mt-4">
        <CTextarea label="Reason" v-model="reason" placeholder="Give Reason" rows="5" />
      </div>
      <div class="border-top mt-2 pt-5">
        <div v-if="isApprove" class="w-100 d-flex justify-content-between">
          <p>Are you sure want to approve?</p>
          <div>
            <CButton variant="outline" color="danger" class="mr-2" @click="notApproved()">No</CButton>
            <CButton @click="getApprove(true)" color="success">Yes</CButton>
          </div>
        </div>

        <div v-if="!isApprove && !isReject" class="w-100 d-flex justify-content-end">
          <CButton variant="outline" color="danger" class="mr-2" @click="getReject()">Reject</CButton>
          <CButton v-if="statusType !== 'View'" color="success" @click="getApprove()">Approve</CButton>
        </div>
        <div v-if="isReject" class="w-100 d-flex justify-content-end">
          <CButton variant="outline" color="danger" class="mr-2" @click="isReject = false">Cancel</CButton>
          <CButton @click="getReject(true)" color="success">Submit</CButton>
        </div>
      </div>
    </div>
    <!-- <CModalFooter>
      <CButton variant="outline" color="danger" class="mr-2" @click="isReject = false">Cancel</CButton>
    </CModalFooter> -->
  </CModal>
</template>
<script>
import config from "@/config.js";
import Swal from "sweetalert2";
const Image = () => import("@/components/image.vue");
const downloadImage = () => import("@/components/downloadImage.vue");
const Pdf = () => import("@/components/pdf.vue");
export default {
  components: {
    "image-view": Image,
    "pdf-component": Pdf,
    "download-image": downloadImage
  },
  data() {
    return {
      reason: "",
      isApprove: false,
      isReject: false,
      histories: [
        {
          status: "Pending",
          requestedOn: "13/07/2021 01:13 pm"
        }
      ],
      sendStatus: ""
    };
  },
  props: ["showCenterApprovalModal", "statusType", "centerData"],

  mounted() {
    if (this.statusType === "Reject") {
      this.isReject = true;
    } else {
      this.isReject = false;
    }
  },
  methods: {
    checkIfImage(str) {
      if (str.split(".").pop() !== "pdf") return true;
      return false;
    },

    closeModal() {
      this.$emit("close");
    },
    getReject(valid) {
      this.isReject = true;
      if (valid) {
        this.getAcceptReject("REJECT");
      }
    },
    getApprove(valid) {
      this.isApprove = true;
      if (valid) {
        this.getAcceptReject("APPROVED");
      }
    },
    getAcceptReject(status) {
      let url = `${config.BASE_URL}api/v2/admin/centers/${this.centerData.center_id._id}/document-verification`;
      if (status === "APPROVED") {
        var payload = {
          status: status
        };
      } else {
        var payload = {
          status: status,
          reason: this.reason
        };
      }

      this.$http.post(url, payload).then(res => {
        if (res.body.status) {
          Swal.fire(
            ` ${
              status.toLowerCase() == "reject" ? "Rejected" : "Approved"
            } Successfully`
          );
        } else {
          Swal.fire(res.body.message);
        }
        this.$emit("close");
        this.$emit("refreshList");
      });
    },
    notApproved() {
      this.isApprove = false;
    }
  }
};
</script>